import gql from 'graphql-tag'

export const getModelAttachmentOCRDataQuery = gql`
    query getByQuoteModelRevisionAttachmentId(
        $quoteModelRevisionAttachmentId: UUID!
    ) {
        getModelAttachmentOcrData(
            quoteModelRevisionAttachmentId: $quoteModelRevisionAttachmentId
        ) {
            id
            callsForOffPlatformFinish
            oneSidedTolerances {
                boundingBox
                nominalCoordinate {
                    page
                    x
                    y
                }
            }
            twoSidedTolerances {
                boundingBox
                nominalCoordinate {
                    page
                    x
                    y
                }
            }
            standardDimensions {
                boundingBox
                text
            }
            certificateOfConformanceNotes {
                boundingBox
                text
            }
            materialCertificateNotes {
                boundingBox
                text
            }
            detectionBoundingBoxes {
                pageNumber
                xmin
                xmax
                ymax
                ymin
            }
            foundThreadsInfo {
                id
                commonName
                count
                diameter
                type
                detections {
                    boundingBox
                    text
                }
            }
            sanitizedBoundingBoxes {
                pageNumber
                xmax
                xmin
                ymax
                ymin
            }
            toleranceBlocks {
                nominalCoordinate {
                    page
                    x
                    y
                }
                boundingBox
                textRaw
                symbol
            }
            allReamableOneSidedTolerances {
                boundingBox
                nominalCoordinate {
                    page
                    x
                    y
                }
            }
            allReamableTwoSidedTolerances {
                boundingBox
                nominalCoordinate {
                    page
                    x
                    y
                }
            }
        }
    }
`
